import React, { useState, Fragment, useEffect } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import Select from "react-select";
import AddVillageDetails from "./AddVillageDetails";
import { connect } from "react-redux";
import Spinner from "../layout/Spinner";
import Pagination from "../layout/Pagination";
import { getAllVillages } from "../../actions/area";
import EditVillageDetails from "./EditVillageDetails";
const AllVillages = ({
  auth: { allUser, isAuthenticated, user, users },
  area: { allBlock, villageData },

  getAllVillages,
  //   getAllBlock,
}) => {
  useEffect(() => {
    getAllVillages();
  }, []);
  //Add
  const [showAddStateModal, setShowAddStateModal] = useState(false);
  const handleAddStateModalClose = () => setShowAddStateModal(false);
  const onClickHandler = () => {
    setShowAddStateModal(true);
  };

  //Edit
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const handleUpdateModalClose = () => setShowUpdateModal(false);
  const [userData, setUserData] = useState(null);
  const onEdit = (villages, idx) => {
    setShowUpdateModal(true);
    setUserData(villages);
  };

  const onUpdateModalChange = (e) => {
    if (e) {
      handleUpdateModalClose();
    }
  };

  //pagination code
  const [currentData, setCurrentData] = useState(1);
  const [dataPerPage] = useState(8);
  //Get Current Data
  const indexOfLastData = currentData * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentDatas =
    villageData && villageData.slice(indexOfFirstData, indexOfLastData);
  //change page
  const paginate = (nmbr) => {
    setCurrentData(nmbr);
  };
  useEffect(() => {}, []);

  //pagination code ends
  return !isAuthenticated || !user || !users ? (
    <Spinner />
  ) : (
    <Fragment>
      <div className="container container_align ">
        <section className="sub_reg">
          <div className="row col-lg-11 col-md-12 col-sm-12 col-12 no_padding">
            <div className="row col-lg-5 col-md-11 col-sm-10 col-10">
              <h5 className="heading_color">All Village Details </h5>
              <div className="col-lg-5 col-md-11 col-sm-11 col-11">
                {user.userGroupName === "Super Admin" && (
                  <Select
                    name="institutionName"
                    // options={allinstitution}
                    // isSearchable={true}
                    // value={institution}
                    placeholder="Institution"
                    // onChange={(e) => onInstitutionChange(e)}
                    theme={(theme) => ({
                      ...theme,
                      height: 26,
                      minHeight: 26,
                      borderRadius: 1,
                      colors: {
                        ...theme.colors,
                        primary: "black",
                      },
                    })}
                  />
                )}
              </div>
            </div>
            {user.userGroupName !== "Super Admin" && (
              <div className="col-lg-7 col-md-1 col-sm-1 col-1 py-4">
                <img
                  className="img_icon_size log float-right"
                  onClick={() => onClickHandler()}
                  src={require("../../static/images/add-icon.png")}
                  alt="Add Block"
                  title="Add Block"
                />
              </div>
            )}
          </div>

          <div className="row">
            <div className="col-lg-11 col-md-12 col-sm-12 col-12 text-center py-2">
              <section className="body">
                <div className=" body-inner no-padding table-responsive">
                  <table
                    className="table table-bordered table-striped table-hover"
                    id="datatable2"
                  >
                    <thead>
                      <tr>
                        <th>Village Name</th>
                        {/* <th>District</th> */}
                        {user.userGroupName !== "Super Admin" && <th>Op</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {currentDatas &&
                        currentDatas.map((villageData, idx) => {
                          return (
                            <tr key={idx}>
                              <td>{villageData.villageName}</td>
                              {/* <td>
                                {allBlock &&
                                  allBlock.output[0] &&
                                  allBlock.output[0].districtName}
                              </td> */}
                              {user.userGroupName !== "Super Admin" && (
                                <td>
                                  {/* <img
                                    className="img_icon_size log"
                                    onClick={() => onUpdate(districtData, idx)}
                                    src={require("../../static/images/delete.png")}
                                    alt="Deactivate"
                                    title="Deactivate"
                                  />{" "} */}
                                  &nbsp;
                                  <img
                                    className="img_icon_size log"
                                    onClick={() => onEdit(villageData, idx)}
                                    src={require("../../static/images/edit_icon.png")}
                                    alt="Edit Block"
                                    title="Edit Block"
                                  />
                                </td>
                              )}
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12 no_padding">
                    {villageData && villageData.length !== 0 ? (
                      <Pagination
                        dataPerPage={dataPerPage}
                        totalData={villageData.length}
                        paginate={paginate}
                        currentPage={currentData}
                      />
                    ) : (
                      <Fragment />
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12 align_right">
                    <label>No. of Villages : {villageData.length}</label>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
        <Modal
          show={showAddStateModal}
          backdrop="static"
          keyboard={false}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <div className="col-lg-10">
              <h3 className="modal-title text-center">Add Village Details</h3>
            </div>
            <div className="col-lg-2">
              <button onClick={handleAddStateModalClose} className="close">
                <img
                  src={require("../../static/images/close.png")}
                  alt="X"
                  style={{ height: "20px", width: "20px" }}
                />
              </button>
            </div>
          </Modal.Header>
          <Modal.Body>
            <AddVillageDetails
              setShowAddStateModal={setShowAddStateModal}

              //   onAddDistrictModalChange={onAddDistrictModalChange}
            />
          </Modal.Body>
        </Modal>
        <Modal
          show={showUpdateModal}
          backdrop="static"
          keyboard={false}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <div className="col-lg-10">
              <h3 className="modal-title text-center">Edit village Details </h3>
            </div>
            <div className="col-lg-2">
              <button onClick={handleUpdateModalClose} className="close">
                <img
                  src={require("../../static/images/close.png")}
                  alt="X"
                  style={{ height: "20px", width: "20px" }}
                />
              </button>
            </div>
          </Modal.Header>
          <Modal.Body>
            <EditVillageDetails
              villages={userData}
              setShowUpdateModal={setShowUpdateModal}
            />
          </Modal.Body>
        </Modal>

        <Modal
          //   show={showDeactiveModal}
          backdrop="static"
          keyboard={false}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <div className="col-lg-10">
              <h3 className="modal-title text-center">Deactivate Block</h3>
            </div>
            <div className="col-lg-2">
              <button className="close">
                <img
                  src={require("../../static/images/close.png")}
                  alt="X"
                  style={{ height: "20px", width: "20px" }}
                />
              </button>
            </div>
          </Modal.Header>
          {/* <Modal.Body>
            <DeactiveBlock
              districtData={userDatas}
              onDeactiveModalChange={onDeactiveModalChange}
            />
          </Modal.Body> */}
        </Modal>
      </div>
    </Fragment>
  );
};

AllVillages.propTypes = {
  auth: PropTypes.object.isRequired,
  area: PropTypes.object.isRequired,
  shg: PropTypes.object.isRequired,
  getAllVillages: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  area: state.area,
  shg: state.shg,
});

export default connect(mapStateToProps, {
  getAllVillages,
  //   getStates,
})(AllVillages);
